import * as entities from '../entities'
import * as grs from '../grs'
import * as auth from '../auth'
import { entitySelector } from '../wordpress/selectors'
import { pendingSelector } from 'api/selectors'
import { createDenormalizedSelector } from 'entities/selectors'
import { newsSchema } from 'wordpress/schemas'

export const dashboardViewSelector = entitySelector('dashboard')
export const dashboardBackgroundSelector = createSelector(
    dashboardViewSelector,
    dashboard => dashboard && dashboard.background
)

const stateSelector = state => state.dashboardRecentTransactions

const unsortedRecentReservationsSelector = entities.selectors.createDenormalizedSelector(stateSelector, [
    grs.schemas.reservationSchema,
])

export const recentReservationsSelector = createSelector(unsortedRecentReservationsSelector, reservations =>
    [...reservations].sort((a, b) => (a.createdDate.isAfter(b.createdDate) ? -1 : 1))
)

const denormalizedNewsSelector = state => state.dashboardRecentNews
export const newsSelector = createDenormalizedSelector(denormalizedNewsSelector, [newsSchema])

export const promotionsSelector = createSelector(auth.selectors.userSelector, user => (user ? user.coupons : []))

export const reservationPendingSelector = createSelector(pendingSelector, pending => pending.getReservations)
